var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "privacy" } },
    [
      _c(
        "b-card",
        { staticClass: "content" },
        [
          _c("b-card-header", [_vm._v("Privacy Policy")]),
          _c("b-card-body", { staticClass: "content-body" }, [
            _c("h3", [_vm._v("PRIVACY STATEMENT")]),
            _c("h3", [
              _vm._v("SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?")
            ]),
            _c("p", [
              _vm._v(
                "When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address."
              )
            ]),
            _c("p", [
              _vm._v(
                "When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system."
              )
            ]),
            _c("p", [
              _vm._v(
                "Email marketing : With your permission, we may send you emails about our store, new products and other updates."
              )
            ]),
            _c("h3", [_vm._v("SECTION 2 - CONSENT")]),
            _c("p", [_c("strong", [_vm._v("How do you get my consent?")])]),
            _c("p", [
              _vm._v(
                "When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only."
              )
            ]),
            _c("p", [
              _vm._v(
                "If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no."
              )
            ]),
            _c("p", [_c("strong", [_vm._v("How do I withdraw my consent?")])]),
            _c("p", [
              _vm._v(
                "If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at "
              ),
              _c("a", { attrs: { href: "mailto:support@pro-tekt.com.au" } }, [
                _vm._v("support@pro-tekt.com.au")
              ]),
              _vm._v(" or mailing us at: ")
            ]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("Pennatek Investments")]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("P.O.Box 1092, ")]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("Bakery Hill, ")]),
            _c("p", [_vm._v("Vic 3354")]),
            _c("h3", [_vm._v("SECTION 3 - DISCLOSURE")]),
            _c("p", [
              _vm._v(
                "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service."
              )
            ]),
            _c("h3", [_vm._v("SECTION 4 - SHOPIFY")]),
            _c("p", [
              _vm._v(
                "Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you."
              )
            ]),
            _c("p", [
              _vm._v(
                "Your data is stored through Shopify’s data storage, databases and the general Shopify application. They store your data on a secure server behind a firewall."
              )
            ]),
            _c("p", [_c("strong", [_vm._v("Payment:")])]),
            _c("p", [
              _vm._v(
                "If you choose a direct payment gateway to complete your purchase, then Shopify stores your credit card data. It is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS). Your purchase transaction data is stored only as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is deleted."
              )
            ]),
            _c("p", [
              _vm._v(
                "All direct payment gateways adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover."
              )
            ]),
            _c("p", [
              _vm._v(
                "PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers."
              )
            ]),
            _c("p", [
              _vm._v(
                "For more insight, you may also want to read Shopify’s Terms of Service ( "
              ),
              _c(
                "a",
                { attrs: { href: "https://www.shopify.com/legal/terms" } },
                [_vm._v("https://www.shopify.com/legal/terms")]
              ),
              _vm._v(") or Privacy Statement ("),
              _c(
                "a",
                { attrs: { href: "https://www.shopify.com/legal/privacy" } },
                [_vm._v(" https://www.shopify.com/legal/privacy")]
              ),
              _vm._v(").")
            ]),
            _c("h3", [_vm._v("SECTION 5 - THIRD-PARTY SERVICES")]),
            _c("p", [
              _vm._v(
                "In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us."
              )
            ]),
            _c("p", [
              _vm._v(
                "However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions."
              )
            ]),
            _c("p", [
              _vm._v(
                "For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers."
              )
            ]),
            _c("p", [
              _vm._v(
                "In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located."
              )
            ]),
            _c("p", [
              _vm._v(
                "As an example, if you are located in Canada and your transaction is processed by a payment gateway located in the United States, then your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act."
              )
            ]),
            _c("p", [
              _vm._v(
                "Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service."
              )
            ]),
            _c("p", [_c("strong", [_vm._v("Links")])]),
            _c("p", [
              _vm._v(
                "When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements."
              )
            ]),
            _c("h3", [_vm._v("SECTION 6 - SECURITY")]),
            _c("p", [
              _vm._v(
                "To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed."
              )
            ]),
            _c("p", [
              _vm._v(
                "If you provide us with your credit card information, the information is encrypted using secure socket layer technology (SSL) and stored with a AES-256 encryption. Although no method of transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements and implement additional generally accepted industry standards."
              )
            ]),
            _c("h3", [_vm._v("SECTION 7 - COOKIES")]),
            _c("p", [
              _vm._v(
                "Here is a list of cookies that we use. We’ve listed them here so you that you can choose if you want to opt-out of cookies or not."
              )
            ]),
            _c("p", [
              _vm._v(
                "_session_id, unique token, sessional, Allows Shopify to store information about your session (referrer, landing page, etc)."
              )
            ]),
            _c("p", [
              _vm._v(
                "_shopify_visit, no data held, Persistent for 30 minutes from the last visit, Used by our website provider’s internal stats tracker to record the number of visits"
              )
            ]),
            _c("p", [
              _vm._v(
                "_shopify_uniq, no data held, expires midnight (relative to the visitor) of the next day, Counts the number of visits to a store by a single customer."
              )
            ]),
            _c("p", [
              _vm._v(
                "cart, unique token, persistent for 2 weeks, Stores information about the contents of your cart."
              )
            ]),
            _c("p", [
              _vm._v(
                "_secure_session_id, unique token, sessional, storefront_digest, unique token, indefinite If the shop has a password, this is used to determine if the current visitor has access."
              )
            ]),
            _c("h3", [_vm._v("SECTION 8 - AGE OF CONSENT")]),
            _c("p", [
              _vm._v(
                "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site."
              )
            ]),
            _c("h3", [_vm._v("SECTION 9 - CHANGES TO THIS PRIVACY POLICY")]),
            _c("p", [
              _vm._v(
                "We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it."
              )
            ]),
            _c("p", [
              _vm._v(
                "If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you."
              )
            ]),
            _c("h3", [_vm._v("QUESTIONS AND CONTACT INFORMATION")]),
            _c("p", [
              _vm._v(
                "If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at "
              ),
              _c("a", { attrs: { href: "mailto:support@pro-tekt.com.au" } }, [
                _vm._v("support@pro-tekt.com.au")
              ]),
              _vm._v(" or by mail at:")
            ]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("Pennatek Investments")]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("[Re: Privacy Compliance Officer]")
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("P.O. Box 1092 Bakery Hill")
            ]),
            _c("p", [_vm._v("Vic 3354")])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }